import React from "react";
import {
  Modal,
  Select,
  DatePicker,
  Radio,
  InputNumber,
  TreeSelect,
} from "antd";
import moment from "moment";
const { Option } = Select;

export const CarryForwadTaxModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "1rem",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Tax Return/Filing Year <span style={{ color: "red" }}>*</span>
            </h3>
            {console.log("datatatata",data)}
            <DatePicker
              mode="year"
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"YYYY"}
              placeholder="Tax Return/Filing Year"
              name="year"
              value={data && data.year && moment.utc(data.year)}
              id="newDate"
              onPanelChange={(value) => {
                console.log("dadadada",value,value)
                handleChange("year", value ? value.format("YYYY") : null); // Pass only the year string
              }}
              // onChange={(date, dateString) => {
              //   handleChange("year", date);
              // }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Short Term/Long Term</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={data && data.term}
              onChange={(value, id) => {
                console.log("value", value);
                handleChange("term", value);
              }}
            >
              {["Short Term", "Long Term"].map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Amount of Carryforward Used
            </h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Amount of Carryforward Used"
                name="amountUsed"
                value={data && data.amountUsed}
                id="amountUsed"
                onChange={(value) => {
                    handleChange("amountUsed", value);
                }}
              />
            </div>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Amount of Carryforward Remaining{" "}
            
            </h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Amount of Carryforward Remaining"
                name="amountRemain"
                value={data && data.amountRemain}
                id="amountRemain"
                onChange={(value) => {
                  handleChange("amountRemain", value);
                }}
              />
            </div>
          </div>

        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.year}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
